import { render } from "./B2bTableRecadvsEmit.vue?vue&type=template&id=5ea22139&scoped=true&lang=pug"
import script from "./B2bTableRecadvsEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableRecadvsEmit.vue?vue&type=script&lang=js"

import "./B2bTableRecadvsEmit.vue?vue&type=style&index=0&id=5ea22139&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea22139"]])

export default __exports__